import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo_small.png'
import _imports_2 from '@/assets/icons/arrow-circle-broken-right.svg'
import _imports_3 from '@/assets/icons/arrow-circle-broken-left.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  src: _imports_2,
  alt: "arrow-circle-broken-right"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_3,
  alt: "arrow-circle-broken-left"
}
const _hoisted_4 = { class: "body" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "body__list--child"
}
const _hoisted_7 = {
  key: 1,
  class: "body__list--hover"
}

import {
  Bell03,
  MessageDotsSquare,
  Users03,
  AlertCircle,
  UserCircle,
  Bookmark,
  Clipboard,
  Phone
} from "utruckin-icons";
import {useRoute, useRouter} from "vue-router";
import {ref, Component} from "vue";

interface IMainItem {
  name: string;
  router: string;
  icon: Component;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WidgetSidebar',
  setup(__props) {

const mainItems: IMainItem[] = [
  {
    name: "Messages",
    router: "/message",
    icon: Bell03,
  },
  {
    name: "Chats",
    router: "/chat",
    icon: MessageDotsSquare,
  },
  {
    name: "Groups",
    router: "/group",
    icon: Users03,
  },
  {
    name: "Errors",
    router: "/errors",
    icon: AlertCircle,
  },
  {
    name: "Accounts",
    router: "/account",
    icon: UserCircle,
  },
  {
    name: "Saved",
    router: "/saved",
    icon: Bookmark,
  },
  {
    name: "Shifts",
    router: "/shifts",
    icon: Clipboard,
  },
  {
    name: "Contacts",
    router: "/contacts",
    icon: Phone,
  },
];

const router = useRouter();
const route = useRoute();

const isWide = ref<boolean>(true);

const goToPage = (item: IMainItem) => {
  router.push(item.router);
};

const goToHome = () => {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-w-sidebar", isWide.value ? 'wide' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (isWide.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_0,
            width: "142",
            height: "36",
            alt: "company_logo",
            onClick: goToHome
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            width: "38",
            height: "32",
            src: _imports_1,
            alt: "company_logo_small",
            onClick: goToHome
          })),
      _createElementVNode("div", {
        class: "header__icon",
        onClick: _cache[0] || (_cache[0] = 
          () => {
            isWide.value = !isWide.value;
          }
        )
      }, [
        (isWide.value)
          ? (_openBlock(), _createElementBlock("img", _hoisted_2))
          : (_openBlock(), _createElementBlock("img", _hoisted_3))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(mainItems, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "body__list"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["body__list--item", _unref(route).path == item.router ? 'active' : '']),
            onClick: ($event: any) => (goToPage(item))
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
              class: "icon",
              size: 20
            })),
            _createTextVNode(" " + _toDisplayString(isWide.value ? item.name : ""), 1)
          ], 10, _hoisted_5),
          (_unref(route).path == item.router)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          (!isWide.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.name), 1))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ])
  ], 2))
}
}

})